<template>
	<div class="col-4- mb-2- mt-4- position-relative">
		<router-link :to="{ name: 'Event', params: { id: id } }">
			<div class="museum-event-button">
				<div class="image" :style="style"></div>
				<div class="content">
					<h1>{{ eventDate }}</h1>
					<h2>{{ subTitle }}</h2>
					<p class="description" v-html="description"></p>
					<h3 class="read-more">{{ t('default_text.read_more')}}</h3>

				</div>
			</div>
		</router-link>
	</div>
</template>

<script>
import { useI18n } from "vue-i18n";

export default {
	name: "GalleryOverviewItem",
	props: {
		title: String,
		image: String,
		id: Number,
	},
	computed: {
		setup() {
			const { t, te, tm } = useI18n();
			return { t, te, tm };
		},
		style() {
			return `background-image: url('${this.image}')`;
		},
		eventDate() {
			const { t, te, tm } = useI18n();

			const dateFrom = new Date(t(`event[${this.id}].date_from`));

			return `${dateFrom.getDate()} ${this.getMonthName(dateFrom.getMonth())} ${dateFrom.getFullYear()}`;
		},
		subTitle() {
			const { t, te, tm } = useI18n();

			return t(`event[${this.id}].subtitle`);
		},
		description() {
			const { t, te, tm } = useI18n();

			let description = t(`event[${this.id}].description`);

			let words = description.split(" ");

			let shortDescription = "";

			let max = 15;

			if (max > words.length) {
				max = words.length;
			}

			for (let i = 0; i < max; i++) {
				shortDescription += words[i];
			}

			return description;
		},
	},
	setup() {
		const { t, te, tm } = useI18n();
		return { t, te, tm };
	},
};
</script>

<style scoped>
.museum-event-button {
	width: 674px;
	height: 277px;
	background-color: #fff;
	display: flex;
}

.image {
	min-width: 214px;
	height: 214px;
	margin-left: 32px;
	margin-top: auto;
	margin-bottom: auto;
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;
}

.content {
	margin: 45px 32px 30px 18px;
    display: flex;
    flex-direction: column;
	color: #3B3B3B;
}

.content h1 {
	font-size: 25px;
	font-weight: bold;
	
}

.content h2 {
	font-size: 20px;
	font-weight: 500;
}

.content p {
	margin-top: 10px;
	font-size: 18px;
}

.description {
	max-height: 5.5em;
	text-overflow: ellipsis;
	word-wrap: break-word;
	overflow: hidden;
}

.read-more {
	margin-top: auto;
    font-weight: bold;
	font-size: 20px;
}

.read-more::after {
    content: '';
    display: inline-flex;
    margin-left: 12px;
    width: 20px;
    height: 20px;
    background-color: #3B3B3B;
    clip-path: polygon(55% 50%, 0 0, 0 100%);
    padding-bottom: 5px;
}
</style>